import Grid from '@mui/material/Grid2';

import Column from '../../../../../components/Column';
import theme from '../../../../../theme';
import { useReportingDashboardPageContext } from '../../../../../hooks/useReportingDashboardPage';

import PerformanceAverageCPMBasicBarChartCard from '../Metrics/PerformanceAverageCPMBasicBarChartCard';
import PerformanceAverageCPMByStrategyTypeBasicBarChartCard from '../Metrics/PerformanceAverageCPMByStrategyTypeBasicBarChartCard';
import PerformanceByStrategyTypeGroupedBarChartCard from '../Metrics/PerformanceByStrategyTypeGroupedBarChartCard';
import PerformanceGroupedBarChartCard from '../Metrics/PerformanceGroupedBarChartCard';
import PerformanceInvestmentByStrategyTypePieChartCard from '../Metrics/PerformanceInvestmentByStrategyTypePieChartCard';
import PerformanceInvestmentPieChartCard from '../Metrics/PerformanceInvestmentPieChartCard';

export default function PerformanceChartView() {
    const { isFetchingPerformances, reportingCriteria } = useReportingDashboardPageContext();

    return (
        <Column gap={3}>
            <Grid container spacing={2}>
                <Grid
                    size={{
                        xl: 6,
                        xs: 12,
                    }}
                >
                    {reportingCriteria?.mediaType !== '' ? (
                        <PerformanceInvestmentByStrategyTypePieChartCard loading={isFetchingPerformances} />
                    ) : (
                        <PerformanceInvestmentPieChartCard loading={isFetchingPerformances} />
                    )}
                </Grid>

                <Grid
                    size={{
                        xl: 6,
                        xs: 12,
                    }}
                >
                    {reportingCriteria?.mediaType !== '' ? (
                        <PerformanceAverageCPMByStrategyTypeBasicBarChartCard loading={isFetchingPerformances} />
                    ) : (
                        <PerformanceAverageCPMBasicBarChartCard loading={isFetchingPerformances} />
                    )}
                </Grid>
            </Grid>
            <Grid sx={{ mt: theme.spacing(1) }} size={12}>
                {reportingCriteria?.mediaType !== '' ? (
                    <PerformanceByStrategyTypeGroupedBarChartCard loading={isFetchingPerformances} />
                ) : (
                    <PerformanceGroupedBarChartCard loading={isFetchingPerformances} />
                )}
            </Grid>
        </Column>
    );
}
